import { always } from 'ramda'
import { createReducer } from '../../utilities/miscellaneous'

// marketSpaces initial state
export const INITIAL_STATE = {
  isSubmitting: false,
}

// marketSpaces action types
export const CLICK = 'marketSpaces/CLICK'
export const CLICKED = 'marketSpaces/CLICKED'
export const ERROR = 'marketSpaces/ERROR'

// click :: String -> Action.CLICK
export const click = id => ({
  type: CLICK,
  id,
})

// clicked :: () -> Action CLICKED
export const clicked = always({ type: CLICKED })

// error :: () -> Action ERROR
export const error = always({ type: ERROR })

// marketSpaces :: (State, Action *) -> State
export default createReducer(INITIAL_STATE, {
  [CLICK]: state => ({
    ...state,
    isSubmitting: true,
  }),

  [CLICKED]: state => ({
    ...state,
    isSubmitting: false,
  }),

  [ERROR]: state => ({
    ...state,
    isSubmitting: false,
  }),
})
